(function () {
  /**
   * Try to relocate Swish wishlist content next to the AAC button.
   * Returns true if relocation completed (or was already done), false if the
   * wishlist block is still empty (caller should keep observing for late
   * content injection).
   */
  function tryRelocate() {
    var source = document.querySelector('.product-info__block--wishlist');
    var target = document.querySelector('.product-info__add-to-cart');

    if (!source || !target) return true; // nothing to do, no point retrying
    if (source.dataset.wishlistRelocated === 'true') return true;

    // Skip if the wrapper has no element children yet (Swish hasn't rendered).
    if (!source.querySelector('*')) return false;

    var wrapper = document.createElement('div');
    wrapper.className = 'product-info__wishlist-aside';
    while (source.firstChild) {
      wrapper.appendChild(source.firstChild);
    }
    target.appendChild(wrapper);
    source.dataset.wishlistRelocated = 'true';
    source.setAttribute('hidden', '');
    return true;
  }

  /* ----------------------------------------------------------------
     IB-600: notifica (toast) in alto a destra all'aggiunta / rimozione
     di un prodotto dalla wishlist.
     L'app (Wishlist King) muta lo stato del bottone dopo il click: leggiamo
     lo stato prima e dopo (con un piccolo delay) e mostriamo il messaggio
     coerente. Se lo stato non e' determinabile, messaggio neutro.
  ---------------------------------------------------------------- */
  var TOAST_TIMEOUT = null;

  function isWishlisted(aside) {
    if (!aside) return false;
    // Ri-query del bottone ad ogni controllo: Wishlist King ri-renderizza il
    // bottone al toggle, quindi un riferimento cached diventa stale.
    var btn = aside.querySelector('.wk-button, button, a, [role="button"]') || aside;
    var cls = (btn.className || '').toString().toLowerCase();
    // Segnale affidabile Wishlist King: classe wk-selected = gia' nei preferiti.
    if (/\bwk-selected\b/.test(cls)) return true;
    // Fallback: testo del bottone. "Aggiunto ..." (con la t) = in lista;
    // "Aggiungi ..." = non in lista. /aggiunt/ matcha solo "Aggiunto".
    var wk = aside.querySelector('.wk-text');
    if (wk && /aggiunt/i.test(wk.textContent || '')) return true;
    if (btn.getAttribute('aria-pressed') === 'true') return true;
    return /(wk-active|in-wishlist|is-active)/.test(cls);
  }

  function getToastRoot() {
    var root = document.querySelector('.wishlist-toast-region');
    if (root) return root;
    root = document.createElement('div');
    root.className = 'wishlist-toast-region';
    root.setAttribute('role', 'status');
    root.setAttribute('aria-live', 'polite');
    document.body.appendChild(root);
    return root;
  }

  function showToast(added) {
    var root = getToastRoot();
    var msg = added
      ? 'Prodotto aggiunto ai preferiti'
      : 'Prodotto rimosso dai preferiti';

    var el = document.createElement('div');
    el.className =
      'wishlist-toast wishlist-toast--' + (added ? 'added' : 'removed');
    el.innerHTML =
      '<span class="wishlist-toast__icon" aria-hidden="true">' +
      (added ? '&#10003;' : '&#10005;') +
      '</span><span class="wishlist-toast__text"></span>' +
      '<button type="button" class="wishlist-toast__close" aria-label="Chiudi">&#10005;</button>';
    el.querySelector('.wishlist-toast__text').textContent = msg;
    root.appendChild(el);

    // Forza reflow per attivare la transizione di entrata.
    void el.offsetWidth;
    el.classList.add('is-visible');

    // Chiusura (auto dopo timeout breve, o manuale col bottone).
    function dismiss() {
      if (TOAST_TIMEOUT) clearTimeout(TOAST_TIMEOUT);
      TOAST_TIMEOUT = null;
      el.classList.remove('is-visible');
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 300);
    }

    el.querySelector('.wishlist-toast__close').addEventListener('click', dismiss);

    if (TOAST_TIMEOUT) clearTimeout(TOAST_TIMEOUT);
    TOAST_TIMEOUT = setTimeout(dismiss, 1800);
  }

  function bindWishlistNotification() {
    var aside = document.querySelector('.product-info__wishlist-aside');
    if (!aside || aside.dataset.toastBound === 'true') return;

    aside.dataset.toastBound = 'true';

    // Wishlist King aggiorna lo stato del bottone gia' DURANTE il click (il suo
    // handler gira prima del nostro), quindi leggere lo stato "dopo" risulta
    // invertito. Catturiamo l'INTENTO in fase di capture (pointerdown/touch),
    // PRIMA che WK inverta: se ora NON e' nei preferiti -> il click aggiungera'.
    var willAdd = null;
    function captureIntent() {
      willAdd = !isWishlisted(aside);
    }
    aside.addEventListener('pointerdown', captureIntent, true);
    aside.addEventListener('mousedown', captureIntent, true);
    aside.addEventListener('touchstart', captureIntent, true);

    aside.addEventListener('click', function () {
      // Usa l'intento catturato pre-toggle; fallback allo stato corrente.
      var added = willAdd != null ? willAdd : isWishlisted(aside);
      willAdd = null;
      showToast(added);
    });
  }

  function init() {
    var relocated = tryRelocate();
    if (relocated) {
      bindWishlistNotification();
      return;
    }

    // The wishlist app block exists but is still empty: Swish probably injects
    // its button after DOMContentLoaded via its own JS. Watch for child
    // additions and relocate as soon as content appears.
    var source = document.querySelector('.product-info__block--wishlist');
    if (!source || !('MutationObserver' in window)) return;

    var observer = new MutationObserver(function () {
      if (tryRelocate()) {
        bindWishlistNotification();
        observer.disconnect();
      }
    });
    observer.observe(source, { childList: true, subtree: true });

    // Safety net: disconnect after 10s regardless, so we don't keep watching
    // forever if Swish is broken or disabled.
    setTimeout(function () {
      observer.disconnect();
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
